const getBrowser = () => {
    const userAgentString = navigator.userAgent;
    let isChrome = userAgentString.includes('Chrome');
    let isSafari = userAgentString.includes('Safari');
    const isFirefox = userAgentString.includes('Firefox');
    const isEdge = userAgentString.includes('Edg');
    // chrome annoyingly also has "Safari" in userAgent
    if (isChrome && isSafari)
        isSafari = false;
    // edge is chromium based so will flag true for chrome
    if (isEdge && isChrome)
        isChrome = false;
    const toString = () => {
        if (isChrome) {
            return 'Chrome';
        }
        if (isFirefox) {
            return 'Firefox';
        }
        if (isEdge) {
            return 'Edge';
        }
        if (isSafari) {
            return 'Safari';
        }
        return userAgentString;
    };
    return {
        isChrome,
        isFirefox,
        isEdge,
        isSafari,
        toString
    };
};
export default getBrowser;
